import React, { Component } from 'react'
import { connect } from 'react-redux'
import { searchSubmit, searchDelIssuesItem, searchResetForm, searchSortResult } from '../actions/issue'
import PublicSearchComponent from '../components/PublicSearch'
import AuthModel from '../models/AuthModel'
import { Redirect } from 'react-router-dom'

class PublicSearch extends Component {

    render() {
        if (!AuthModel.isAuthenticated()) {
            AuthModel.lastRoute = '/search'
            return <Redirect to='/login' />
        }
        return (
            <PublicSearchComponent {...this.props} />
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.search)
    nextProps['auth'] = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        search: (formData) => {
            dispatch(searchSubmit(formData))
        },
        remove: (item) => {
            dispatch(searchDelIssuesItem(item))
        },
        reset: () => {
            dispatch(searchResetForm())
        },
        onTableChange: (pagination, filters, sorter) => {
            dispatch(searchSortResult(sorter));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicSearch)



// WEBPACK FOOTER //
// ./src/containers/PublicSearch.js